
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22 22.34l-2.527-2.476L22 17.387l-1.685-1.66-2.516 2.49-2.515-2.49-1.685 1.66 2.527 2.477L13.6 22.34 15.284 24l2.515-2.489L20.315 24M2.373 0C1.056 0 0 1.052 0 2.337v18.695c0 1.297 1.056 2.337 2.373 2.337h9.268a6.968 6.968 0 01-.867-2.337h-8.4V2.337h8.306v5.842h5.933v4.767a8.124 8.124 0 011.186-.093c.404 0 .795.035 1.187.093V7.011L11.866 0m-7.12 11.684v2.337h9.493v-2.337m-9.493 4.674v2.337h5.934v-2.337H4.746z","fill":"#B71C1C"}})])
          )
        }
      }
    